// import {settings} from '../../config/config'
// import SocketService from '../../services/SocketService'



// // mutation例子,
// // action函数
// export const toggleMap=(state)=>{
//     // 判断是否需要socket, 如果
//     if(settings.enableSocket){
//         SocketService.getInstance().emit('test',{
//             type: 'toggleMap'
//         })

//     }else{
//         toggleMapDone(state)
//     }
// }

//actionDone函数
export const toggleMapDone=(state)=>{
    state.needShow = !state.needShow
}


export const setLang=(state,lang)=>{
    state.lang=lang+'/'
}

export const setCur=(state,cur)=>{
    state.cur=cur
}